import React from 'react'

const CardReport = (props) => {
    return (
        <div className="col-xl-3">
            <a className="card bg-primary hoverable card-xl-stretch mb-xl-8 h-md-90">
                <div className="card-body">
                    <span className="svg-icon svg-icon-white svg-icon-3x ms-n1">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mh-50px"><rect x="8" y="9" width="3" height="10" rx="1.5" fill="currentColor"></rect><rect opacity="0.5" x="13" y="5" width="3" height="14" rx="1.5" fill="currentColor"></rect><rect x="18" y="11" width="3" height="8" rx="1.5" fill="currentColor"></rect><rect x="3" y="13" width="3" height="6" rx="1.5" fill="currentColor"></rect></svg>
                    </span>
                    <div className="text-white fw-bold fs-3 mb-2 mt-5">
                        {props.title}
                    </div>
                    <div className="fw-semibold fs-5 text-white">
                        {props.sub_title}
                    </div>
                </div>
            </a>
        </div>
    )
}

export default CardReport;